"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListedBuilding$ = exports.ListedBuilding$outboundSchema = exports.ListedBuilding$inboundSchema = exports.Location$ = exports.Location$outboundSchema = exports.Location$inboundSchema = void 0;
exports.locationToJSON = locationToJSON;
exports.locationFromJSON = locationFromJSON;
exports.listedBuildingToJSON = listedBuildingToJSON;
exports.listedBuildingFromJSON = listedBuildingFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const multipointmodel_js_1 = require("./multipointmodel.js");
const pointmodel_js_1 = require("./pointmodel.js");
/** @internal */
exports.Location$inboundSchema = z.union([pointmodel_js_1.PointModel$inboundSchema, multipointmodel_js_1.MultiPointModel$inboundSchema]);
/** @internal */
exports.Location$outboundSchema = z.union([pointmodel_js_1.PointModel$outboundSchema, multipointmodel_js_1.MultiPointModel$outboundSchema]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Location$;
(function (Location$) {
    /** @deprecated use `Location$inboundSchema` instead. */
    Location$.inboundSchema = exports.Location$inboundSchema;
    /** @deprecated use `Location$outboundSchema` instead. */
    Location$.outboundSchema = exports.Location$outboundSchema;
})(Location$ || (exports.Location$ = Location$ = {}));
function locationToJSON(location) {
    return JSON.stringify(exports.Location$outboundSchema.parse(location));
}
function locationFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Location$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Location' from JSON`);
}
/** @internal */
exports.ListedBuilding$inboundSchema = z.object({
    amended_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    distance_in_metres: z.nullable(z.number().int()),
    grade: z.string(),
    id: z.string(),
    listed_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    location: z.union([pointmodel_js_1.PointModel$inboundSchema, multipointmodel_js_1.MultiPointModel$inboundSchema]),
    name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "amended_date": "amendedDate",
        "distance_in_metres": "distanceInMetres",
        "listed_date": "listedDate",
    });
});
/** @internal */
exports.ListedBuilding$outboundSchema = z.object({
    amendedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    distanceInMetres: z.nullable(z.number().int()),
    grade: z.string(),
    id: z.string(),
    listedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    location: z.union([
        pointmodel_js_1.PointModel$outboundSchema,
        multipointmodel_js_1.MultiPointModel$outboundSchema,
    ]),
    name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        amendedDate: "amended_date",
        distanceInMetres: "distance_in_metres",
        listedDate: "listed_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListedBuilding$;
(function (ListedBuilding$) {
    /** @deprecated use `ListedBuilding$inboundSchema` instead. */
    ListedBuilding$.inboundSchema = exports.ListedBuilding$inboundSchema;
    /** @deprecated use `ListedBuilding$outboundSchema` instead. */
    ListedBuilding$.outboundSchema = exports.ListedBuilding$outboundSchema;
})(ListedBuilding$ || (exports.ListedBuilding$ = ListedBuilding$ = {}));
function listedBuildingToJSON(listedBuilding) {
    return JSON.stringify(exports.ListedBuilding$outboundSchema.parse(listedBuilding));
}
function listedBuildingFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ListedBuilding$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ListedBuilding' from JSON`);
}
//# sourceMappingURL=listedbuilding.js.map